import { createContainer } from 'usage-tracker-multi';
import { makeUuid } from 'usage-tracker-core/common/helpers';
import {
  getPortalAccountId,
  getPortalInstanceId,
  getPortalName,
} from './metadata';

const { createTracker } = createContainer({ storeUuidOnUrl: false });

export const usageTracker = createTracker({
  allowUnauthed: true,
  standalone: true,
  trackerType: 'public',
  isExternalHost: true,
  properties: {
    email: null,
    isOwner: null,
    deviceId: makeUuid,
    hubId: getPortalAccountId,
    channelId: getPortalInstanceId,
    channelName: getPortalName,
  },
});

let hasTrackedInit = false;

export function trackPortalInitialized({
  email,
  isOwner,
}: {
  email?: string;
  isOwner?: boolean;
}): void {
  if (hasTrackedInit) {
    return;
  }

  if (isOwner) {
    usageTracker.setProperties({ isOwner: true });
  }

  if (email) {
    usageTracker.setProperties({ email });
    usageTracker.track('Portals Platform', 'Portal Initialized', {});
    hasTrackedInit = true;
  }
}
